"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleApolloError = void 0;
const processApolloError_1 = require("./processApolloError");
const ApolloErrorHandlerResult_1 = require("./ApolloErrorHandlerResult");
const handleApolloError = (error, app, context) => {
    const { unhandledErrors, handledErrors } = (0, processApolloError_1.processApolloError)(error, {
        app,
        context,
        onUnauthorizedError: error => {
            console.warn('Unauthorized! Logging you out...', error);
            return true;
        },
    });
    unhandledErrors.forEach(error => {
        console.error(`${error.type}: ${error.message}`, error.error);
    });
    return new ApolloErrorHandlerResult_1.ApolloErrorHandlerResult(unhandledErrors, handledErrors);
};
exports.handleApolloError = handleApolloError;
//# sourceMappingURL=handleApolloError.js.map